<template>
  <div>
    <Pane />

    <div class="container">
      <a-form
        :form="form"
        @submit="handleSubmit"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申领人</span>
              <a-button block style="text-align: left">
                {{ user.userName }}
              </a-button>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申领部门</span>
              <a-button block style="text-align: left">
                {{ department.deptUniqueName }}
              </a-button>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="办公室位置"
            >
              <a-input
                v-decorator="[
                  'officeLocation',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="联系电话"
            >
              <a-input
                v-decorator="[
                  'phone',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <div class="between">
          <div class="title">采购申请清单</div>
          <div style="display: flex; justify-content: flex-end;gap:10px">
            <a-button type="" @click="$router.push('/oa/purchaseMaterials')">查看物资目录</a-button>
            <AddMaterial @add="add" :canEdit="true"/>
          </div>
        </div>

        <a-table bordered :dataSource="list" :pagination="false">
          <a-table-column title="商品名称" data-index="name"> </a-table-column>
        <a-table-column title="规格型号" data-index="spec"> </a-table-column>
        <a-table-column title="颜色" data-index="color"> </a-table-column>

        <a-table-column title="单位" data-index="unit" align="center">
        </a-table-column>
        <a-table-column title="单价" align="center">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ text.price }}</span>
          </template>
        </a-table-column>
        <a-table-column title="数量" align="center">
          <template slot-scope="text">
            <a-input-number
              :min="1"
              :max="99999999"
              v-model.number="text.num"
            />
          </template>
        </a-table-column>
        <a-table-column title="备注" data-index="remark"> </a-table-column>
        <a-table-column title="分类" data-index="category"> </a-table-column>


          <a-table-column title="操作" align="center" width="100px">
            <template slot-scope="text, record, index">
              <a href="#" class="danger" @click.prevent="remove(index)">
                移除
              </a>
            </template>
          </a-table-column>
        </a-table>

        <div class="center">
          <a-space>
            <a-button htmlType="submit" type="primary" :loading="loading">
              {{ id ? "重新提交" : "保存" }}
            </a-button>
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import AddMaterial from "./components/add-material.vue";
import { apply, fetchApplyDetail, reapply } from "@/api/oa/purchaseMaterials";
export default {
  components: {
    AddMaterial,
  },

  data() {
    return {
      form: this.$form.createForm(this),

      list: [],

      loading: false,

      id: null, // 已发起申领申请的 id
    };
  },

  mounted() {
    const { query } = this.$route;
    const { id } = query || {};

    if (id) {
      // 重新提交
      this.id = id;
      fetchApplyDetail({
        id,
      }).then((res) => {
        console.log("result", res);
        if (res) {
          this.form.setFieldsValue({
            officeLocation: res.officeLocation,
            phone: res.phone,
          });

          this.list = Array.isArray(res.subList)
            ? res.subList
            : [];
        }
      });
    }
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["department"]),

    ...mapGetters("setting", ["findDataDict"]),

    typeList() {
      return this.findDataDict("giftType");
    },
  },

  methods: {
    renderSubType(type, subType) {
      const obj = this.typeList.find((item) => item.value === type);
      if (obj && Array.isArray(obj.children)) {
        const subTypeObj = obj.children.find((item) => item.value === subType);
        if (subTypeObj) {
          return subTypeObj.name;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    // 用户选择了品名和数量
    add(payload) {
      const index = this.list.findIndex((item) => item.id === payload.id);
      if (index === -1) {
        this.list.push(payload);
      } else {
        this.list.splice(index, 1, payload);
      }
    },

    remove(index) {
      this.list.splice(index, 1);
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.list.length === 0) {
            this.$message.error("请添加申领物料");
            return;
          }

          this.loading = true;
          const { officeLocation, phone } = values;

          if (this.id) {
            reapply({
              id: this.id ? this.id : undefined,

              // 申领人
              applicantId: this.user.uuid,
              applicantName: this.user.userName,
              // 申领部门
              departmentId: this.department.deptId,
              departmentName: this.department.deptUniqueName,

              officeLocation,
              phone,
              subList: this.list,
            })
              .then(() => {
                this.$close(this.$route.path);
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            apply({
              // 申领人
              applicantId: this.user.uuid,
              applicantName: this.user.userName,
              // 申领部门
              departmentId: this.department.deptId,
              departmentName: this.department.deptUniqueName,

              officeLocation,
              phone,

              subList: this.list,
            })
              .then(() => {
                this.list = [];
                this.form.resetFields();
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.title {
  margin-top: 30px;
  margin-bottom: 18px;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  color: #1890ff;
}

.center {
  margin-top: 80px;
}
</style>
